import {
  Controller,
  Control,
  FieldErrors,
  UseFormWatch,
} from 'react-hook-form';
import { RulesEngineFormValues } from '../rules-engine-form-page';
import ActionDescription from './action-description';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

interface Props {
  description?: string;
  control: Control<RulesEngineFormValues>;
  errors: FieldErrors<RulesEngineFormValues>;
  watch: UseFormWatch<RulesEngineFormValues>;
}

export default function LimitOccurrencesAction({
  control,
  errors,
  description,
}: Props) {
  return (
    <Box>
      <ActionDescription description={description} />
      <Controller
        name="actionInfo.occurrenceLimit"
        control={control}
        render={({ field }) => (
          <TextField
            sx={{ width: '200px' }}
            {...field}
            type="number"
            slotProps={{
              input: {
                inputProps: { min: 0 },
              },
            }}
            label="Occurrences Limit"
            fullWidth
            autoComplete="off"
            error={!!errors?.actionInfo?.occurrenceLimit}
            helperText={errors?.actionInfo?.occurrenceLimit?.message || ''}
            onChange={(e) =>
              field.onChange(
                e.target.value ? Number(e.target.value) : e.target.value
              )
            }
          />
        )}
      />
    </Box>
  );
}
